
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(225|423|772)|4399|5170|5965|8124)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
